import Usuario from "./Usuario";
import StatusProcesso from "./StatusProcesso";
import DecisaoProcesso from "./DecisaoProcesso";
import StatusDetranProcessamento from "./StatusDetranProcessamento";
import TipoRecorrente from "./TipoRecorrente";
import TipoProcesso from "./TipoProcesso";
import Notificacao from "./Notificacao";
import DomPublicacaoRecurso from "./DomPublicacaoRecurso";

class Processo {
    constructor(
        {
            id = null,
            notificacao_id = null,
            ano_processo = null,
            numero_processo = null,
            tipo_recorrente_id = null,
            data_solicitacao_considerada = null,
            data_solicitacao_real = null,
            status_processo_id = null,
            ind_procurador = null,
            cpf_solicitante = null,
            nome_solicitante = null,
            email_solicitante = null,
            cpf_cnpj_recorrente = null,
            email_recorrente = null,           
            nome_recorrente = null,                                                                                                                 
            protocolo_bhdigital = null,
            tipo_processo_id = null,
            tipo_documento_id = null,
            status_detran_processamento_id = null,
            ind_alteracao_julgamento = null,
            ind_movimentacao_em_transito = null,
            numero_documento_cnh = null,
            tipo_documento_cnh_id = null,            
            decisao_processo_id = null,
            data_solicitacao_cancelamento_entrada = null,
            julgador_usuario_id = null,
            data_resultado = null,
            data_ult_atualizacao = null,
            motivo_cancelamento_ait_id = null,
            motivo_nao_acolhimento_processo_id = null,
            ind_emissao_carta = null,
            data_entrada_sram = null,
            data_resultado_sram = null,
            data_cobranca_obrigatoria_sram = null,
            data_cancelamento_entrada_sram = null,
            data_cancelamento_resultado_sram = null,
            comunicacao_cidadao = null,
            comunicacao_interna_pbh = null,
            usuario_alteracao_julgamento_id = null,
            data_alteracao_julgamento = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            usuario = {},
            status_processo = {},
            decisao_processo = {},
            status_detran_processamento = {},
            tipo_recorrente = {},
            tipo_recorrente_procurador = {},
            tipo_processo = {},
            documento_processo = [],
            notificacao = {},
            data_cancelamento_entrada = null,
            
            //campos que não sao da tabela
            num_ait_composto = null,
            placa_veiculo = null,
            codigo_renavam = null,
            proprietario = null,
            proprietario_documento = null,
            julgador_nome = null,
            sintese_selecionada = [],
            ind_exibilidade_sne=null,
            ind_advertencia_por_escrito=null,
            data_limite_emitir_nap=null,
            forma_captacao=null,
            dom_publicacao_recurso = []
            
        } = {}
    ) {
        this.id = id,
        this.notificacao_id = notificacao_id;
        this.ano_processo = ano_processo;
        this.numero_processo = numero_processo;
        this.tipo_recorrente_id = tipo_recorrente_id;
        this.data_solicitacao_considerada = data_solicitacao_considerada;
        this.data_solicitacao_real = data_solicitacao_real;
        this.status_processo_id = status_processo_id;
        this.ind_procurador = ind_procurador;
        this.cpf_solicitante = cpf_solicitante;
        this.nome_solicitante = nome_solicitante;
        this.email_solicitante = email_solicitante;           
        this.cpf_cnpj_recorrente = cpf_cnpj_recorrente;
        this.email_recorrente = email_recorrente;
        this.nome_recorrente = nome_recorrente;                                                                     
        this.protocolo_bhdigital = protocolo_bhdigital;
        this.tipo_processo_id = tipo_processo_id;
        this.tipo_documento_id = tipo_documento_id;
        this.status_detran_processamento_id = status_detran_processamento_id;
        this.ind_alteracao_julgamento = ind_alteracao_julgamento;
        this.ind_movimentacao_em_transito = ind_movimentacao_em_transito;
        this.numero_documento_cnh = numero_documento_cnh;
        this.tipo_documento_cnh_id = tipo_documento_cnh_id;        
        this.decisao_processo_id = decisao_processo_id;
        this.data_solicitacao_cancelamento_entrada = data_solicitacao_cancelamento_entrada;        
        this.data_resultado = data_resultado;
        this.data_ult_atualizacao = data_ult_atualizacao;
        this.motivo_cancelamento_ait_id = motivo_cancelamento_ait_id;
        this.motivo_nao_acolhimento_processo_id = motivo_nao_acolhimento_processo_id;
        this.ind_emissao_carta = ind_emissao_carta;
        this.data_entrada_sram = data_entrada_sram;
        this.data_resultado_sram = data_resultado_sram;
        this.data_cobranca_obrigatoria_sram = data_cobranca_obrigatoria_sram;
        this.data_cancelamento_entrada_sram = data_cancelamento_entrada_sram;
        this.data_cancelamento_resultado_sram = data_cancelamento_resultado_sram;
        this.data_cancelamento_entrada = data_cancelamento_entrada;
        this.comunicacao_cidadao = comunicacao_cidadao;
        this.comunicacao_interna_pbh = comunicacao_interna_pbh;
        this.usuario_alteracao_julgamento_id = usuario_alteracao_julgamento_id;
        this.data_alteracao_julgamento = data_alteracao_julgamento;
        this.num_ait_composto = num_ait_composto;
        this.codigo_renavam = codigo_renavam;
        this.placa_veiculo = placa_veiculo;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.documento_processo = documento_processo;
        this.proprietario = proprietario;
        this.proprietario_documento = proprietario_documento;
        this.julgador_nome = julgador_nome;
        this.sintese_selecionada = sintese_selecionada;
        this.ind_exibilidade_sne = ind_exibilidade_sne;
        this.ind_advertencia_por_escrito =ind_advertencia_por_escrito;
        this.data_limite_emitir_nap = data_limite_emitir_nap;
        this.forma_captacao = forma_captacao;
        this.julgador_usuario_id = julgador_usuario_id;
        
        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.status_processo = status_processo ? new StatusProcesso(status_processo) : new StatusProcesso();
        this.decisao_processo = decisao_processo ? new DecisaoProcesso(decisao_processo) : new DecisaoProcesso();
        this.status_detran_processamento = status_detran_processamento ? new StatusDetranProcessamento(status_detran_processamento) : new StatusDetranProcessamento();
        this.tipo_recorrente = tipo_recorrente ? new TipoRecorrente(tipo_recorrente) : new TipoRecorrente();
        this.tipo_recorrente_procurador = tipo_recorrente_procurador ? new TipoRecorrente(tipo_recorrente_procurador) : new TipoRecorrente();
        this.tipo_processo = tipo_processo ? new TipoProcesso(tipo_processo) : new TipoProcesso();
        this.notificacao = notificacao ? new Notificacao(notificacao) : new Notificacao();


        this.dom_publicacao_recurso = dom_publicacao_recurso && Array.isArray(dom_publicacao_recurso) && dom_publicacao_recurso.length > 0 ? dom_publicacao_recurso.map(dom => {return new DomPublicacaoRecurso(dom)}) : [];

        
    }
}

export default Processo;